import React from 'react';
import landingGif from '../landinggif.gif';

const Splash = ({ onEnter }) => {
    return (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/90 backdrop-blur-sm">
            <div className="flex flex-col items-center space-y-8 p-4">
                <img
                    src={landingGif}
                    alt="Welcome to $TITSTR"
                    className="w-full max-w-md object-contain rounded-lg shadow-2xl"
                />
                <button
                    onClick={onEnter}
                    className="px-8 py-3 text-xl font-bold text-black bg-white rounded-full hover:bg-gray-200 transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-[0_0_20px_rgba(255,255,255,0.3)]"
                >
                    Enter $TITSTR
                </button>
            </div>
        </div>
    );
};

export default Splash;
